/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file isInFlight selector
 * @author Roland Scott
 * @module react-async-hook\internal\state\selectors\is-in-flight
 */

import { IAsyncState } from "../../";

/**
 * Return whether the given execution is currently in flight
 * @state The async state
 * @param id The ID of the execution to look at
 */
export function isInFlight(state: IAsyncState, id: number): boolean {
	if (!state) {
		throw Error("State not defined");
	}
	if (!state.executions) {
		throw Error("Executions not defined");
	}
	if (!state.executions[id]) {
		throw Error(`Execution ${id} does not exist`);
	}
	return state.executions[id].inFlight;
}
